<template>
  <div id="contenedor-main-listado-fianzas">
    <template v-if="!$vuetify.breakpoint.xs">
      <desktop :listadoFianzas="listadoFianzas"></desktop>
    </template>
    <template v-else>
      <mobile :listadoFianzas="listadoFianzas"></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoFianzas',
  props: {
    listadoFianzas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
